import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ChevronLeft, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Avatar";
import { ProfilePosts } from "@/components/profile/ProfilePosts";

export default function MemberProfile() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const highlightId = params.get("post");
  const [m, setM] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setM(null); setErr(null);
    api.get(`/members/${id}`).then(({ data }) => setM(data)).catch((e) => setErr(e.response?.status || 500));
  }, [id]);

  if (err) {
    return (
      <div className="px-4 pt-6 pb-6 max-w-2xl mx-auto" data-testid="member-not-found">
        <Link to="/comunidades" className="inline-flex items-center gap-1 text-sm text-zinc-600 mb-6"><ChevronLeft size={16} /> Voltar</Link>
        <div className="bg-white rounded-2xl border border-zinc-200 p-8 text-center text-sm text-zinc-600">Perfil não disponível.</div>
      </div>
    );
  }
  if (!m) return <div className="px-4 pt-6 text-sm text-zinc-500">A carregar…</div>;

  return (
    <div className="px-4 pt-4 pb-6 max-w-2xl mx-auto" data-testid="member-profile">
      <button type="button" onClick={() => window.history.back()} className="inline-flex items-center gap-1 text-sm text-zinc-600 mb-4" data-testid="member-back"><ChevronLeft size={16} /> Voltar</button>
      <div className="bg-white rounded-2xl border border-zinc-200 p-4 mb-6 flex items-start gap-4">
        <Avatar src={m.photo_url} name={m.name} size={72} testId="member-avatar" />
        <div className="flex-1 min-w-0">
          <h1 className="font-display text-xl font-extrabold leading-tight break-words" data-testid="member-name">{m.name}</h1>
          {m.city && <div className="text-xs text-zinc-500 inline-flex items-center gap-1 mt-0.5" data-testid="member-city"><MapPin size={12} /> {m.city}</div>}
          {m.bio && <p className="text-sm text-zinc-700 mt-2 whitespace-pre-wrap break-words" data-testid="member-bio">{m.bio}</p>}
          {m.is_me && <Link to="/perfil" className="inline-block mt-2 text-xs font-semibold underline" data-testid="member-edit-link">Editar o meu perfil</Link>}
        </div>
      </div>
      <ProfilePosts userId={m.id} isOwner={m.is_me} highlightId={highlightId} />
    </div>
  );
}
